import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Toast from '../Toast/Toast.js';
import styles from './ToastWrapper.scss.js';

const TOAST_CONTAINER_ID = 'np-toasts-container';
const ANIMATION_DURATION = 1000;
// This component has no visual representation, it only works
// as a wrapper to position the Toast component

const ToastWrapper = _ref => {
  let {
    toasts
  } = _ref;
  const toastsContainer = useMemo(() => {
    let auxToastsContainer = document.getElementById(TOAST_CONTAINER_ID);
    if (!auxToastsContainer) {
      auxToastsContainer = document.createElement('div');
      auxToastsContainer.setAttribute('id', TOAST_CONTAINER_ID);
      document.body.appendChild(auxToastsContainer);
    }
    return auxToastsContainer;
  }, []);
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(TransitionGroup, null, toasts.map(toast => /*#__PURE__*/React.createElement(CSSTransition, {
    timeout: ANIMATION_DURATION,
    classNames: {
      enter: styles['toast-enter'],
      enterActive: styles['toast-enter-active'],
      enterDone: styles['toast-enter-done'],
      exitActive: styles['toast-exit-active'],
      exitDone: styles['toast-exit-done']
    },
    key: toast.id
  }, /*#__PURE__*/React.createElement(Toast, {
    toast: toast
  }))))), toastsContainer);
};
var ToastWrapper$1 = ToastWrapper;

export { ToastWrapper$1 as default };
//# sourceMappingURL=ToastWrapper.js.map
